import React, { FC, useCallback, useState } from 'react';
import { Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import { ExtendedUser } from '../../../../shared/user/extended';
import { PIIAccessWarning } from '../../../components';
import { useTranslation } from '../../../translations';

interface EmergencyContactInfo {
  emergencyContactName1?: string;
  emergencyContactName2?: string;
  emergencyContactPhone1?: string;
  emergencyContactPhone2?: string;
}

export const UserEmergencyTab: FC<{ readonly userData: ExtendedUser }> = ({ userData }) => {
  const [data, setData] = useState<EmergencyContactInfo>();
  const handleConfirm = useCallback(async () => {
    setData(
      await api.request<EmergencyContactInfo>(
        `/api/users/${userData.id}/registration/emergencycontacts`,
      ),
    );
  }, [userData.id]);

  return (
    <PIIAccessWarning onConfirm={handleConfirm}>
      <EmergencyContacts data={data} />
    </PIIAccessWarning>
  );
};

const EmergencyContacts: FC<{ readonly data?: EmergencyContactInfo }> = ({ data }) => {
  return (
    <Row>
      <RenderedContactInfo
        contactName={data?.emergencyContactName1}
        id={1}
        phone={data?.emergencyContactPhone1}
      />
      <RenderedContactInfo
        contactName={data?.emergencyContactName2}
        id={2}
        phone={data?.emergencyContactPhone2}
      />
    </Row>
  );
};

const RenderedContactInfo: FC<{
  readonly id: number;
  readonly contactName?: string;
  readonly phone?: string;
}> = ({ id, contactName, phone }) => {
  const { ts } = useTranslation();
  const hasInfo = contactName && phone;
  return (
    <Col className="mb-10" lg={6} xs={12}>
      <Card>
        <CardBody>
          <CardTitle>{ts('emergency_contact_info')}</CardTitle>
          {!hasInfo && (
            <CardText className="text-danger">
              {ts('contact_information_was_not_provided')}
            </CardText>
          )}
          {hasInfo && (
            <>
              <CardText>
                <strong>{ts('name')}</strong>:{' '}
                <span id={`emergencyContactName${id}`}>{contactName}</span>
              </CardText>
              <CardText>
                <strong>{ts('phone')}</strong>:{' '}
                <span id={`emergencyContactPhone${id}`}>{phone}</span>
              </CardText>
            </>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};
